interface BreadcrumbItem {
  name: string;
  url: string;
}

interface SEOBreadcrumbsProps {
  items?: BreadcrumbItem[];
}

export const SEOBreadcrumbs = ({ items }: SEOBreadcrumbsProps) => {
  // Compute breadcrumbs synchronously to avoid using hooks
  const pathname = typeof window !== 'undefined' ? window.location.pathname : "/";
  const pathItems = items && items.length > 0 ? items : generateBreadcrumbsFromPath(pathname);

  if (!pathItems || pathItems.length <= 1) return null;

  const breadcrumbStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": pathItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://sortable.uk${item.url}`
    }))
  };

  return (
    <script
      id="breadcrumb-structured-data"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
    />
  );
};

const generateBreadcrumbsFromPath = (pathname: string): BreadcrumbItem[] => {
  const breadcrumbs: BreadcrumbItem[] = [{ name: "Home", url: "/" }];

  const pathMap: Record<string, string> = {
    "/about": "About Us",
    "/about-us": "About Us",
    "/how-it-works": "How It Works",
    "/pricing": "Pricing",
    "/for-tradesmen": "For Tradesmen",
    "/success-stories": "Success Stories",
    "/auth": "Sign In",
    "/create-job": "Post a Job",
    "/admin": "Admin Dashboard"
  };

  if (pathname !== "/" && pathMap[pathname]) {
    breadcrumbs.push({
      name: pathMap[pathname],
      url: pathname
    });
  }

  return breadcrumbs;
};